export const getScrollParent = (node: HTMLElement): Element | null => {
  const isElement = node instanceof HTMLElement;
  const overflowY = isElement && window.getComputedStyle(node as HTMLElement).overflowY;
  const isScrollable = overflowY !== "visible" && overflowY !== "hidden";

  if (!node) {
    return null;
  } else if (isScrollable && node.scrollHeight >= node.clientHeight) {
    return node;
  }

  return getScrollParent(node.parentNode as HTMLElement) || document.scrollingElement;
};

export const getElementNodeIndex = (element: HTMLElement): number => {
  const parentElement = element.parentElement;
  return parentElement ? Array.from(parentElement.childNodes).indexOf(element) : -1;
};

export const getClosestNode = <T extends HTMLElement>(node: T, compareNode: T | string): HTMLElement => {
  if (typeof compareNode === "string") {
    if (node.tagName === compareNode.toUpperCase()) return node;
    let tempNode = node;
    while (tempNode && tempNode.tagName !== compareNode.toUpperCase()) {
      tempNode = tempNode.parentNode as T;
    }
    return tempNode;
  } else {
    if (node === compareNode) return node;
    let tempNode = node;
    while (tempNode && tempNode !== compareNode) {
      tempNode = tempNode.parentNode as T;
    }
    return tempNode;
  }
};

// Util function to find whether a class lies in the parent heirarchy or self element
export const checkClosestClassSelector = (
  className: string,
  targetElement: HTMLElement,
  boundingElement: HTMLElement
): boolean => {
  let tempElement: HTMLElement | null = targetElement;
  let result = false;
  while (tempElement && tempElement !== boundingElement) {
    if (tempElement.classList.contains(className)) {
      result = true;
      break;
    }
    tempElement = tempElement.parentElement;
  }
  return result;
};
